import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { usersApi, type CreateUserPayload } from '@/api/users';

const USERS_KEY = ['users'] as const;

export const useUsers = () =>
  useQuery({ queryKey: USERS_KEY, queryFn: () => usersApi.list(), staleTime: 30_000 });

export const useCreateUser = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (p: CreateUserPayload) => usersApi.create(p),
    onSuccess:  () => {
      qc.invalidateQueries({ queryKey: USERS_KEY });
      qc.invalidateQueries({ queryKey: ['me', 'colleagues'] }); // refresh dropdown collègues
    },
  });
};
